import React, { Component } from "react"
import Chart from "react-apexcharts"
import colorArray from "helpers/colorArray"
import numeral from "numeral"
import _ from "lodash"

//https://codepen.io/indreed/pen/qBOxJmB
//? This floating bar is for prices, if dates are needed we may need another.  For some reason, the floating bar from Apex only is setup for dates, not prices, thus hacks below.
//? Currently this is used on the averages report for showing builder + lot type  on a floating bar scale.  May need to rename or pull this logic into the component directly.  Not sure this is meant for reuse.
class FloatingBar extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		let options = {
			chart: {
				type: "rangeBar",
			},
			toolbar: {
				show: true,
				tools: {
					download: true,
					selection: true,
					zoom: true,
					zoomin: true,
					zoomout: true,
					pan: true,
					reset: true,
				},
			},
			plotOptions: {
				bar: {
					horizontal: true,
					barHeight: "100%",
				},
			},
			tooltip: {
				x: {
					formatter: function (value) {
						if (typeof value == "number") return numeral(value).format("$0,0")
						return value
					},
				},
			},
			xaxis: {
				type: "datetime",
				labels: {
					formatter: function (value, timestamp, opts) {
						return numeral(value).format("$0,0")
					},
				},
			},
			stroke: {
				width: 1,
				colors: ["#fff"],
			},
			colors: colorArray,
			fill: {
				opacity: 1,
			},
			legend: {
				position: "top",
				horizontalAlign: "left",
				offsetX: 40,
			},
			grid: {
				show: true,
				borderColor: "#E5E5E5",
				strokeDashArray: 0,
				position: "back",
				xaxis: {
					lines: {
						show: true,
					},
				},
				yaxis: {
					lines: {
						show: true,
					},
				},
				row: {
					colors: undefined,
					opacity: 0.5,
				},
				column: {
					colors: undefined,
					opacity: 0.5,
				},
				padding: {
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				},
			},
			dataLabels: {
				enabled: true,
				style: {
					colors: ["#FFF"],
					fontSize: "11px",
				},
				dropShadow: {
					enabled: true,
					top: 2,
					left: 2,
					blur: 2,
					color: "#000",
					opacity: 0.4,
				},
				borderColor: "#000",
				hideOverflowingLabels: false,
				formatter: (value, opts) => {
					if (_.has(this.props.series, `${opts.seriesIndex}.name`)) {
						return this.props.series[opts.seriesIndex].name
					}
					return ""
				},
			},
		}
		let cats = []
		let low = 0
		_.forEach(this.props.series, (v) => {
			_.forEach(v.data, (r) => {
				cats.push(r.x)
				if (low < r.y[0]) low = r.y[0]
			})
		})
		// To get the categories to sort, we have to add dummy records to the first array entry.
		cats = _.uniq(cats)
		cats = _.sortBy(cats)
		let series = _.cloneDeep(this.props.series)
		if(_.has(series, `0.data`)) {
			_.forEach(series[0].data, (v) => {
				_.forEach(cats, (r) => {
					if(_.find(series[0].data, {x: r})) return
					series[0].data.push({
						x: r,
						y: [low, low],
					})
				})
			})
			series[0].data = _.orderBy(series[0].data, 'x')
		}
		return <Chart options={options} series={series} type="rangeBar" />
	}
}

export default FloatingBar
